










import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import LoadingSpinner from "@/components/LoadingSpinner.vue"
import appConfig from "@/config"
import {executeQuery} from "@/data/repos/query"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {reformatDate} from "@/data/sources/dates"
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import {AppraisalItem} from "@/data/repos/appraisal"

@Component({
  components: {
    LoadingSpinner,
    DataGrid,
  },
})
export default class AppraisalFacetScoresDrillDown2 extends Vue {
  @Prop() public args!: { locationId: number, row: any, riskId: number, aprItems: AppraisalItem, scoreId: number }
  private surveyName = ""
  private dataGridFields = [
    {name: 'locationPath', title: 'Location', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: this.getLink},
    {name: 'categoryName', title: 'Category', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: this.getLink},
    {name: 'elementName', title: 'Major Element', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: this.getLink},
    {name: 'subelementName', title: 'Subelement', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: this.getLink},
    {name: 'riskLabel', title: 'Risk', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: this.getLink},
    {name: 'costToB', title: 'Cost to B', dataType: DataType.Number, sort: 1, component: DataGridLink, callback: this.getLink},
    {name: 'inspectionDate', title: 'Inspection date', dataType: DataType.Date, sort: 1, component: DataGridLink, callback: this.getLink},
  ]

  public async created() {
    this.surveyName = this.args.aprItems.subelementId ? "Subelement" :
      this.args.aprItems.elementId ? "Major element" :
        this.args.aprItems.categoryId ? "Category" :
          this.args.aprItems.facetId ? "Facet" :
            this.args.aprItems.surveyId ? "Survey" : ""
  }

  private getLink(fieldName: string, row: any): { url: string, text: string } {
    const s = this.args.aprItems.surveyId ? `&surveyid=${encodeURIComponent(this.args.aprItems.surveyId)}` : ""
    const f = this.args.aprItems.facetId ? `&facetid=${encodeURIComponent(this.args.aprItems.facetId)}` : ""
    const h = this.args.aprItems.subelementId ? `&highlight=${encodeURIComponent(this.args.aprItems.subelementId)}` : ""
    return {
      url: `${appConfig.IPR_BASE_URL}/pages/condition/conditionreport2.asp?` +
        `id=${encodeURIComponent(this.args.row.buildingId)}` + s + f + h,
      text: row[fieldName],
    }
  }

  public async getData(offset = 0) {
    if (offset) {
      return []
    }
    return await this.loadData(this.args.locationId, this.args.riskId, this.args.aprItems)
  }

  private async loadData(locationId: number, riskId: number, aprItems: AppraisalItem): Promise<any[] | null> {
    const queryName = aprItems.subelementId ? "appraisal.score.scoreDrillDown2_subelement" :
      aprItems.elementId ? "appraisal.score.scoreDrillDown2_element" :
        aprItems.categoryId ? "appraisal.score.scoreDrillDown2_category" :
          aprItems.facetId ? "appraisal.score.scoreDrillDown2_facet" : null
    const args: any = aprItems.subelementId ? {subelementId: aprItems.subelementId} :
      aprItems.elementId ? {elementId: aprItems.elementId} :
        aprItems.categoryId ? {categoryId: aprItems.categoryId} :
          aprItems.facetId ? {facetId: aprItems.facetId} : null
    args.locationId = locationId
    args.scoreId = this.args.scoreId

    if (queryName) {
      return executeQuery("idr", queryName, args, this.filter)
    }
    return []
  }

  private filter(data: any[]): any[] {
    return data.map((v) => {
      return {
        locationPath: v.locationpath,
        categoryName: v.categoryName,
        elementName: v.elementname,
        subelementName: v.subelementName,
        facetID: v.facetID,
        categoryId: v.categoryID,
        elementId: v.elementID,
        subelementId: v.subelementid,
        riskLabel: v.riskLabel,
        conditionRating: v.conditionRating,
        costToB: formatNumberWithGrouping(v.costToB, 0),
        inspectionDate: v.inspectiondate && reformatDate(v.inspectiondate),
      }
    })
  }
}
